import { calculateShinglesWeight, getRecommendedDumpsterTitleByBundles, getRecommendedDumpsterTitleBySquares, numberWithCommas } from '../../components/calculator/calculations'

export default function shinglesCalculator (calculatorForm, calculatorEstimatedWeightPanel, calculatorResultsPanel, calculatorRecommendedDumpsterTitle, calculatorRecommendedDumpsterImage, toggleResults) {
  const shingleTypesInputWrapper = calculatorForm.querySelector('[data-js-shingles-calculator-shingles-type]')
  let selectedType = 'Three-Tab Asphalt'
  const threeTabAsphaltShinglesLabel = calculatorForm.querySelector('[data-js-shingles-calculator-shingles-type-label="Three-Tab Asphalt"]')
  const slateShinglesLabel = calculatorForm.querySelector('[data-js-shingles-calculator-shingles-type-label="Slate"]')
  const architecturalAsphaltShinglesLabel = calculatorForm.querySelector('[data-js-shingles-calculator-shingles-type-label="Architectural Asphalt"]')
  const squaresInput = calculatorForm.querySelector('[data-js-shingles-calculator-squares-input]')
  const bundlesInput = calculatorForm.querySelector('[data-js-shingles-calculator-bundles-input]')
  const layersInput = calculatorForm.querySelector('[data-js-shingles-calculator-layers-input]')

  calculatorForm.addEventListener('submit', calculateShinglesResults)

  changeLabelBgOnTypeSelected(selectedType)

  shingleTypesInputWrapper.addEventListener('change', handleShinglesTypeChange)
  squaresInput.addEventListener('change', handleNumberInputsChange(bundlesInput))
  bundlesInput.addEventListener('change', handleNumberInputsChange(squaresInput))

  initializeValidation()

  function handleShinglesTypeChange (event) {
    changeLabelBgOnTypeSelected(event.target.value)
    selectedType = event.target.value
  }

  function handleNumberInputsChange (relatedInput) {
    return function (event) {
      const value = event.target.value

      relatedInput.disabled = !!value
    }
  }

  function changeLabelBgOnTypeSelected (selectedType) {
    [threeTabAsphaltShinglesLabel, slateShinglesLabel, architecturalAsphaltShinglesLabel].forEach(label => {
      if (selectedType === label.dataset.jsShinglesCalculatorShinglesTypeLabel) {
        label.classList.remove('text-blue', 'bg-white', 'hover:text-gray')
        label.classList.add('text-white', 'bg-blue')
        return
      }
      label.classList.remove('text-white', 'bg-blue')
      label.classList.add('text-blue', 'bg-white', 'hover:text-gray')
    })
  }

  function calculateShinglesResults (event) {
    event.preventDefault()

    let calculationUnitName = 'squares'
    let calculationUnitValue = squaresInput.value
    if (squaresInput.value === '') {
      calculationUnitName = 'bundles'
      calculationUnitValue = bundlesInput.value
    }

    const { totalWeightPounds, totalWeightTons } = calculateShinglesWeight(selectedType, calculationUnitName, calculationUnitValue, layersInput.value)
    toggleResults()
    calculatorEstimatedWeightPanel.children[0].innerText = `${numberWithCommas(totalWeightPounds)} lbs or ${totalWeightTons} ton(s)`

    calculatorRecommendedDumpsterTitle.innerText = calculationUnitName === 'squares'
      ? getRecommendedDumpsterTitleBySquares(selectedType, squaresInput.value, layersInput.value)
      : getRecommendedDumpsterTitleByBundles(selectedType, bundlesInput.value, layersInput.value)
  }

  function initializeValidation () {
    squaresInput.setAttribute('required', 'true')
    bundlesInput.setAttribute('required', 'true')

    bundlesInput.addEventListener('input', function () {
      if (this.value === '') return squaresInput.setAttribute('required', 'true')
      squaresInput.removeAttribute('required')
    })
    squaresInput.addEventListener('input', function () {
      if (this.value === '') return bundlesInput.setAttribute('required', 'true')
      bundlesInput.removeAttribute('required')
    })
  }
}
